import React from "react";
import styled from "styled-components/macro";

const DesktopOnboarding = ({ author }) => {
  return (
    <DesktopOnboardingContainer>
      <Title>{author} wants your feedback.</Title>
      <Subtitle>To leave a comment, highlight some text below.</Subtitle>
      <OnboardingGif>
        <img
          src="/assets/clean-copy-author-onboarding.gif"
          alt="Onboarding GIF"
        />
      </OnboardingGif>
      <BouncingArrow>
        <a href="#document-title">↓</a>
      </BouncingArrow>
    </DesktopOnboardingContainer>
  );
};

const DesktopOnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  height: calc(100vh - 124px);
`;

const Title = styled.h1({
  fontFamily: '"GT Super Text", serif',
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: 48,
  marginBottom: 0,
  lineHeight: "130%",
  textAlign: "center",
});

const Subtitle = styled.h2({
  width: "80%",
  fontFamily: '"GT Super Text", serif',
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: 20,
  color: "gray",
  marginBottom: 0,
});

const OnboardingGif = styled.div`
  width: 85vw;
  max-width: 500px;
  margin: 20px auto 0 auto;
  /* padding: 10px 0px; */
  /* background-color: #fffdff; */
  box-shadow: var(--card-drop-shadow);
  border-radius: 4px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const BouncingArrow = styled.div`
  font-family: "GT Super";
  font-size: 32px;
  text-align: center;
  animation: bounce 2s infinite;
  margin-top: auto;
  margin-bottom: 120px;

  a {
    text-decoration: none;
    color: inherit;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(10px);
    }
  }
`;

export default DesktopOnboarding;
